import {
	ChangeDetectionStrategy,
	Component,
	Input,
	inject,
} from '@angular/core';
import { Store, dispatch } from '@ngxs/store';
import { BusinessFeatureFlagSelectors } from '@state/business';
import { UserProfileState } from '@state/user-profile';
import { OverwriteFields } from '@state/user-profile/actions';

@Component({
	selector: 'app-ai-scraping-notification',
	templateUrl: './ai-scraping-notification.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class AiScrapingNotificationComponent {
	private OverwriteFields = dispatch(OverwriteFields);
	private store = inject(Store);
	public isHidden$ = this.store.select(UserProfileState.isAiNotificationHidden);
	public isAIEnabled$ = this.store.select(
		BusinessFeatureFlagSelectors.isAIEnabled,
	);
	public _isUsingIntroduceNotification = false;
	@Input() uiCardClass: string;
	@Input() set isUsingIntroduceNotification(value: boolean) {
		this.isHidden$ = this.store.select(
			value
				? UserProfileState.isIntroduceAiCreateMatterModalHidden
				: UserProfileState.isAiNotificationHidden,
		);
		this._isUsingIntroduceNotification = value;
	}

	hideAiNotification() {
		this.OverwriteFields({
			field: `settings.hideNotifications.${this._isUsingIntroduceNotification ? 'hideIntroduceAiCreateMatterModal' : 'hideAiDocumentProcessing'}`,
			value: true,
		});
	}
}
